// extracted by mini-css-extract-plugin
export default {"positive":"styles_positive__TQV1o","negative":"styles_negative__P4yJD"};